import dayjs from 'dayjs'
import { IDefaultSpecialTerms } from '../../../../api/types'
import { TTableDataCountDisplay, TTableHeader } from '@reapitform/common-ui'

const tableHeader: TTableHeader<IDefaultSpecialTerms>[] = [
  {
    headerTitle: 'TEMPLATE NAME',
    key: 'title',
  },
  {
    headerTitle: 'SETTING',
    key: 'useAsDefault',
    getColumnValue: (data) => {
      if (data.useAsDefault) return 'Default'
      return 'Optional'
    },
    columnWidth: '120px',
  },
  {
    headerTitle: 'LAST UPDATED',
    key: 'lastUpdatedUTC',
    getColumnValue: (data) => dayjs(data.lastUpdatedUTC).format('D MMM YYYY'),
    sortable: true,
    sortAs: 'LastActionDate',
    columnWidth: '140px',
  },
]

const tableCountDisplayConfig: TTableDataCountDisplay = {
  singular: 'Template',
  plural: 'Templates',
}

export const specialTermsTableConfig = {
  header: tableHeader,
  countDisplay: tableCountDisplayConfig,
  emptyMessages: 'There are no special conditions templates',
  description:
    'Special condition templates are pre-defined clauses for the General Tenancy Agreement. You can choose to include them by default or leave them as optional selections when creating a new agreement.',
}
